import React, { useState } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import LockIcon from "@mui/icons-material/Lock";
import {
  AlertInfo,
  BtnGroupStyle,
  ContentStyle,
  DRxInputStyle,
  DRxSelectStyle,
  greyColor,
  InputSMBoxStyle,
  RadioGroupStyle,
  warnColor,
  IframeStyle,
} from "../../../Theme";
import { YSButton } from "../../../uikit/YSButton";
import { Form, Formik } from "formik";
import DRxInput from "../../../uikit/DRxInput";
import SearchIcon from "../../../images/icons/SearchIcon.svg";
import { DRxSelect2 } from "../../../uikit/DRxSelect2";
import {
  GenerateSavedPrescriptionReport,
  Initializer,
} from "../../../Apis/AuthApiServices";
import YSSnackBar from "../../../uikit/YSSnackBar";
import useFetch from "../../../CustomHooks/useFetch";
import { useSelector } from "react-redux";
import { REPORT_BASE_URL } from "../../../Apis/Constants";
import { useOnBehalfContext } from "../../../context/OnbehalfContext";

const initialStateSavedPrescriptionReport = {
  VendorName: "DIGITAL RX",
  PracticeName: "Digital Rx Test",
  SearchBy: "",
  DateOfBirth: "",
  UserRole: "Physician",
  RadioData: "",
  ReportType: "PDF",
};

export default function SavedPrescriptionReport() {
  const [data, setData] = useState(initialStateSavedPrescriptionReport);
  const [printActive, setPrintActive] = useState(false);
  const [reportUrl, setReportUrl] = useState();
  const [stateData, setStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const doctorName: any = localStorage.getItem("DoctorName");
  const UserServiceState = useSelector((state: any) => {
    return { ...state?.UserServicesSlice?.ServicesData };
  }); //redux data
  const { onBehalfContext }: any = useOnBehalfContext();
  const { data: initialData, loading }: any = useFetch({}, Initializer, []);
  const [selected, setSelected] = React.useState("doctor");
  const handleDocSelectionChange = (e: any) => {
    const { value } = e.target;
    setSelected(value);
  };

  const getGenerateSavedPrescriptionReport = async () => {
    try {
      const doctorId: any = localStorage.getItem("doctorId");
      const params = new URLSearchParams();
      params.append("doctorId", doctorId);
      params.append("doctors", "");
      params.append(
        "isReportsForAll",
        selected === "allDoctors" ? "true" : "false"
      );

      const result = await GenerateSavedPrescriptionReport(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        if (selected === "allDoctors") {
          setStateData((prevState: any) => {
            return {
              ...prevState,
              message: result?.data?.response[0]?.message,
              variant: "success",
              open: true,
            };
          });
          setPrintActive(false);
        } else {
          setReportUrl(result?.data?.response[0]?.reportName);
          setPrintActive(true);
        }
      } else {
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      setStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Something went Wrong!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  return (
    <>
      <ContentStyle>
        {printActive ? (
          <Grid
            container
            item
            xs={12}
            spacing={0}
            alignItems="top"
            justifyContent="space-between"
            columnSpacing={3}
          >
            <Grid item xs={12}>
              <IframeStyle>
                <iframe src={REPORT_BASE_URL + reportUrl} title="PrintReport" />
              </IframeStyle>
            </Grid>
            <Grid item xs={12}>
              <BtnGroupStyle className="right">
                <YSButton
                  className=""
                  children={"Back"}
                  variant={"outlined"}
                  size={"large"}
                  onClick={() => {
                    setPrintActive(false);
                  }}
                />{" "}
              </BtnGroupStyle>
            </Grid>
          </Grid>
        ) : (
          <>
            <Typography component="h6" color="primary" variant="h6">
              Saved Prescription Report
            </Typography>
            {loading ? (
              <Grid
                container
                justifyContent={"center"}
                alignItems={"center"}
                height={"100vh"}
              >
                <CircularProgress color="primary" />
              </Grid>
            ) : (
              <>
                <Formik
                  initialValues={data}
                  onSubmit={(values) => {
                    setData(values);
                  }}
                >
                  {({
                    handleChange,
                    values,
                    handleBlur,
                    touched,
                    errors,
                    setFieldValue,
                  }) => (
                    <Form>
                      <Grid
                        container
                        item
                        xs={12}
                        spacing={0}
                        alignItems="top"
                        justifyContent="space-between"
                        columnSpacing={3}
                      >
                        <Grid item xs={12} md={6}>
                          <InputSMBoxStyle>
                            <Typography
                              component="label"
                              color={greyColor}
                              variant="body2"
                              htmlFor="vendorname"
                            >
                              Vendor Name
                              <Typography
                                component="span"
                                color={warnColor}
                                variant="body1"
                              >
                                *
                              </Typography>
                            </Typography>{" "}
                            <Box>
                              <DRxInputStyle>
                                <DRxInput
                                  id="vendorname"
                                  name="VendorName"
                                  type="text"
                                  className=""
                                  value={initialData[0]?.vendorName}
                                  disabled={true}
                                  onChange={handleChange}
                                />
                              </DRxInputStyle>
                            </Box>
                          </InputSMBoxStyle>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <InputSMBoxStyle>
                            <Typography
                              component="label"
                              color={greyColor}
                              variant="body2"
                              htmlFor="practicename"
                            >
                              Practice Name
                              <Typography
                                component="span"
                                color={warnColor}
                                variant="body1"
                              >
                                *
                              </Typography>
                            </Typography>{" "}
                            <Box>
                              <DRxInputStyle>
                                <DRxInput
                                  id="practicename"
                                  name="Practice Name"
                                  type="text"
                                  className=""
                                  disabled={true}
                                  value={initialData[0]?.practiceName}
                                  onChange={handleChange}
                                />
                              </DRxInputStyle>
                            </Box>
                          </InputSMBoxStyle>
                        </Grid>
                        <Stack
                          sx={{ width: "100%" }}
                          spacing={2}
                          marginBottom={3}
                          marginLeft={3}
                        >
                          <AlertInfo className="gray ni">
                            <Typography variant="body2" component={"div"}>
                              Select criteria to create a Patient Prescription
                              History and click on the{" "}
                              <Typography
                                fontWeight={600}
                                color={"primary"}
                                component={"span"}
                              >
                                "Generate Report"
                              </Typography>{" "}
                              button.
                            </Typography>{" "}
                          </AlertInfo>
                        </Stack>
                        <Grid item xs={12} md={6}>
                          <InputSMBoxStyle>
                            <Typography
                              component="label"
                              color={greyColor}
                              variant="body2"
                              htmlFor="searchby"
                            >
                              Search by
                              <Typography
                                component="span"
                                color={warnColor}
                                variant="body1"
                              >
                                *
                              </Typography>
                            </Typography>
                            <Box>
                              <DRxInputStyle className="reportSearch">
                                <DRxInput
                                  id="searchby"
                                  className=""
                                  name="SearchBy"
                                  type={"search"}
                                  value={values.SearchBy}
                                  onChange={handleChange}
                                  placeholder="Patient Last name, First name"
                                />
                                <IconButton>
                                  <img
                                    src={SearchIcon}
                                    alt="Search"
                                    loading="lazy"
                                  />
                                </IconButton>
                              </DRxInputStyle>
                            </Box>
                          </InputSMBoxStyle>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <InputSMBoxStyle>
                            <Typography
                              component="label"
                              color={greyColor}
                              variant="body2"
                              htmlFor="userrole"
                            >
                              User Role
                            </Typography>
                            <Box>
                              <DRxSelectStyle>
                                <DRxInput
                                  name="UserRole"
                                  id="userrole"
                                  type="text"
                                  value={initialData[0]?.userRole}
                                  disabled={true}
                                />
                              </DRxSelectStyle>
                            </Box>
                          </InputSMBoxStyle>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <InputSMBoxStyle>
                            <Typography
                              component="label"
                              color={greyColor}
                              variant="body2"
                              htmlFor="userrole"
                            ></Typography>
                            <Box>
                              <RadioGroupStyle>
                                <Radio
                                  checked={selected === "allDoctors"}
                                  onChange={handleDocSelectionChange}
                                  value="allDoctors"
                                  name="radio-buttons"
                                />{" "}
                                All Doctors
                                <Radio
                                  checked={selected === "doctor"}
                                  onChange={handleDocSelectionChange}
                                  value="doctor"
                                  name="radio-buttons"
                                />{" "}
                                {doctorName}
                              </RadioGroupStyle>
                            </Box>
                          </InputSMBoxStyle>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <InputSMBoxStyle>
                            <Typography
                              component="label"
                              color={greyColor}
                              variant="body2"
                              htmlFor="reporttype"
                            >
                              Report Type
                            </Typography>
                            <Box>
                              <DRxSelectStyle>
                                <DRxSelect2
                                  name="ReportType"
                                  id="reporttype"
                                  options={[{ value: "PDF", label: "PDF" }]}
                                  onChange={handleChange}
                                  value={
                                    initialStateSavedPrescriptionReport.ReportType
                                  }
                                />
                              </DRxSelectStyle>
                              <YSButton
                                style={{ marginTop: 35 }}
                                size="large"
                                className=""
                                color="primary"
                                dataTestId="submitBtn"
                                variant="contained"
                                disabled={
                                  // localStorage.getItem("onBehalf")
                                  onBehalfContext?.id &&
                                  UserServiceState?.profileGroup !== 11
                                    ? false
                                    : UserServiceState?.profileGroup > 9
                                    ? true
                                    : false
                                }
                                startIcon={
                                  // localStorage.getItem("onBehalf")
                                  onBehalfContext?.id &&
                                  UserServiceState?.profileGroup !== 11
                                    ? null
                                    : UserServiceState?.profileGroup > 9 && (
                                        <LockIcon />
                                      )
                                }
                                type="submit"
                                children={"Generate Reports"}
                                onClick={() => {
                                  getGenerateSavedPrescriptionReport();
                                }}
                              />
                            </Box>
                          </InputSMBoxStyle>
                        </Grid>
                        <Grid item xs={12} md={6}></Grid>
                        <Grid item xs={12} md={6} textAlign={"center"}></Grid>
                      </Grid>
                    </Form>
                  )}
                </Formik>
              </>
            )}
          </>
        )}
      </ContentStyle>
      <YSSnackBar
        message={stateData.message}
        variant={stateData.variant}
        open={stateData.open}
        handleClose={() => {
          setStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
